import { createFileRoute } from '@tanstack/react-router';
import { requireSession } from '../../auth/require-session.js';
import { SessionError, SessionPending } from '../../auth/SessionStates.js';
import { BootstrapWizard } from '../../bootstrap/wizard.js';

/** `/bootstrap` (2.J deliverable 9): guarded like every other authenticated route. */
export const Route = createFileRoute('/bootstrap/')({
  staticData: { crumb: 'Bootstrap' },
  beforeLoad: async ({ location }) => ({ me: await requireSession(location.pathname) }),
  pendingComponent: SessionPending,
  pendingMs: 0,
  pendingMinMs: 0,
  errorComponent: SessionError,
  component: BootstrapWizard,
});
